import {themeIcons, type ThemeIconKey} from 'platform/foundation';

import {isNotNil} from 'ramda';

/**
 * BE-driven action icon keys are not guaranteed to exist in the icon registry.
 * Button treats any unknown key as a Lottie and renders a permanently-empty
 * 16px slot that pushes the label off-center, so unresolvable keys degrade to
 * a text-only button instead (same membership check as IconCellRenderer).
 */
export const toRegisteredIcon = (value: ThemeIconKey | undefined): ThemeIconKey | undefined =>
  isNotNil(value) && Object.hasOwn(themeIcons, value) ? value : undefined;
